<template>
    <main class=" pt-2 bg-gray-100">
        <section class="d-flex flex-column flex-xl-row">
            <div class="side-nav-container me-4" v-if="width>=breakpoints.screen_laptop">
                <div class="side-nav bg-white">
                  <div class="side-nav-inner">
                    <div
                      class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white"
                    >
                      <div
                      
                        class="d-flex align-items-center flex-shrink-0 p-4 link-dark text-decoration-none border-bottom"
                      >
                        <span class="fs-5 fw-semibold"
                          >Paramètres du compte</span
                        >
                  </div>
                      <div class="list-group-parent">
                  
                        <nuxt-link  v-for="(item , index) of items" class="list-group-childs d-block params-link" :to="`/dashboard/parameter/${item.navTo}`" :key="index">
                          <p class="title">
                            {{ item.title }} 

                          </p>
                        
                        </nuxt-link>
                  
                          
                   
                        <li  class="p-4">
                    <div v-if="dashStore.getUserProfil.isPro && dashStore.getUserProfil.marketplaces[0].verified" class="cards mini-cards col bg-warning-500">
                        <div class="card-body">
                            <h6 class='fw-semiBold text-white'>Ma page professionnelle</h6>
                            <p class="text-white fsz-12 mb-12">
                                Explorez Mon espace professionnel en Ligne
                            </p>
                            <nuxt-link v-if="dashStore.getUserProfil.marketplaces[0]" :to="`/marketplace/${dashStore.getUserProfil.marketplaces[0]?.userName}`" class="btn small-btn btn-border-hidden btn-outline-primary-600 d-inline-flex align-items-center" >
                                <span class="material-symbols-rounded fsz-20 text-warning-500 me-1">arrow_forward</span> 
                                <span class="text-warning-500">Prévisualiser Ma Page</span>
                            </nuxt-link>
                            <nuxt-link v-else to="/marketplace/creation" class="btn small-btn btn-border-hidden btn-outline-primary-600 d-inline-flex align-items-center" >
                                <span class="material-symbols-rounded fsz-20 text-warning-500 me-1">arrow_forward</span> 
                                <span class="text-warning-500">Créer votre espace pro</span>
                            </nuxt-link>
                        </div>
                    </div>
                    <div v-else class="cards mini-cards col bg-primary-600">
                        <div class="card-body">
                            <h6 class='fw-semiBold text-white' >Vous êtes un professionnel?</h6>
                            <p class="text-white fsz-12 mb-12">
                                Créer votre espace pro en ligne
                              </p>
                              <nuxt-link  to="/marketplace/creation" class="btn py-2 px-3 btn-border-hidden btn-outline-primary-600 d-inline-flex align-items-center" >
                                <span class="material-symbols-rounded fsz-20 me-1">arrow_forward</span> 
                                <span >Commence</span>
                            </nuxt-link>
                        </div>
                    </div>
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          <div class="params-container mb-4" v-else-if="width>=breakpoints.screen_smallMobile">
            <div class="bg-white rounded">
              <div class="d-flex gap-2 list-group-parent overflow-auto p-3" ref="el">
                <nuxt-link  v-for="item of items" class="list-group-childs d-block params-link param-item col-auto p-2" :to="`/dashboard/parameter/${item.navTo}`" 
                :key="item.id" :data-item-id="item.id">
                  <p class="title">
                    {{ item.title }} 

                  </p>
                
                </nuxt-link>
              </div>
            </div>
          </div>
          <div class="params-container mb-4" v-else>
            <div class="bg-white rounded">
              <button
                class="btn d-flex align-items-center justify-content-between gap-2 w-100 border-0 py-3"
                @click="showMobileLinks = !showMobileLinks"
              >
                <i class="material-icons-outlined fsz-20">settings</i>
                <span>Paramètres</span>
                <i :class="['pi', showMobileLinks ? 'pi-chevron-up' : 'pi-chevron-down', 'ms-auto']"></i>
              </button>

              <div v-if="showMobileLinks" class="list-group-parent">
                <nuxt-link  v-for="(item , index) of items" class="list-group-childs-mob d-block params-link" :to="`/dashboard/parameter/${item.navTo}`" :key="index">
                  <p class="title">
                    {{ item.title }} 
                  </p>
                </nuxt-link>
              </div>
            </div>
          </div>
          <div class="main-content w-100 d-flex flex-column gap-4 pb-64">
                  <slot />
          </div>
        </section>
    
      </main>
</template>

<script setup lang="ts">
import { breakpoints } from '~/utils/breakpoints.js';

const { renderWidth: width } = useDeviceWidth();
const el = ref<HTMLElement | null>(null)
const dashStore = useDashboardStore();
const route = useRoute();

const infoFacturiel = {
  title: "Informations de facturation",
  id: 5,
  navTo:'Informations_de_facturation',

}

const items = ref([
  {
    title: "Informations personnelles",
    id: 1,
    navTo: 'information_personnel',

  },
  {
    title: "Notifications",
    id: 3,
    navTo:'notifications',

  },

{
  title: "Abonnement & transaction",
  id: 4,
  navTo:'abonnement_et_transaction',

}
]);

const showMobileLinks = ref(false);

onBeforeMount(()=>{
  if (!dashStore.userProfil.providerId) {
    items.value.splice(1, 0, {
      title: "Mot de passe",
      id: 2,
      navTo: 'mot_de_pass'
    });
  }

 
})
const scroll = () => {
  const container = el.value;
  if (!container) return;

  // Trouver l'élément actif
  const activeItem = items.value.find(item => 
    route.path.includes(item.navTo)
  );

  if (activeItem) {
    const selectedItem = container.querySelector(`[data-item-id="${activeItem.id}"]`);
    if (selectedItem instanceof HTMLElement) {
      // Calculer la position de scroll
      const containerWidth = container.offsetWidth;
      const itemLeft = selectedItem.offsetLeft;
      const itemWidth = selectedItem.offsetWidth;
      
      // Centrer l'élément
      const scrollPosition = itemLeft - (containerWidth / 2) + (itemWidth / 2);
      // console.log("selectedItem: ",selectedItem);
      // console.log("containerWidth: ",containerWidth);
      // console.log("itemLeft: ",itemLeft);
      // console.log("itemWidth :",itemWidth);
      // console.log("scrollPosition: ",scrollPosition);
      
      
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  }
};

onMounted(() => {
      if(dashStore.getUserProfil.isPro){
        if (dashStore.getUserProfil.marketplaces[0]) {
          items.value.push(infoFacturiel)
        }
      }
      setTimeout(() => {
        scroll();
      }, 100);
});

</script>

<style lang="scss" scoped>
.side-nav {
    width: 370px;
    padding: 0px;
    top: 162px;
    
  }

  .mini-cards{
    background-image: url(~/assets/images/backgrounds/dashboard_widgets/Icon-Shop.svg);
    background-position-x: 116%;
    background-position-y: 33px;
    background-repeat: no-repeat
}

.list-group-childs-mob{
  &:last-child{
    padding: 12px 18px;
  }
}

</style>
